import { Button, Icon, Table } from "semantic-ui-react";

import { Input } from "simplydo/react/component-library";

const TableField = ({ field, fieldValue, updateIdea, isEditing }) => {
  const currentData = fieldValue?.data || [{}];
  const columns = field.columns || [];

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          {columns.map((col) => (
            <Table.HeaderCell key={col.id}>
              {col.title}
              {col.required ?
                <span style={{ color: "#cd0e2b" }}>{"\u00A0*"} </span>
              : null}
            </Table.HeaderCell>
          ))}
          {isEditing ?
            <Table.HeaderCell />
          : null}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {currentData.map((row, rowIndex) => (
          <Table.Row key={rowIndex}>
            {columns.map((col) => {
              const cell = row[col.id] || { value: "" };

              return (
                <Table.Cell key={col.id}>
                  {isEditing ?
                    <Input
                      fluid
                      value={cell.value}
                      onChange={(e, data) => {
                        const newData = [...currentData];
                        newData[rowIndex][col.id] = { value: data.value };
                        updateIdea({ ...(fieldValue || {}), data: newData }, [
                          "templated",
                          field.id,
                        ]);
                      }}
                    />
                  : cell.value}
                </Table.Cell>
              );
            })}
            {isEditing ?
              <Table.Cell collapsing>
                <Button
                  basic
                  icon
                  onClick={() => {
                    const newData = currentData.filter(
                      (_, i) => i !== rowIndex,
                    );
                    updateIdea({ ...(fieldValue || {}), data: newData }, [
                      "templated",
                      field.id,
                    ]);
                  }}
                >
                  <Icon name="trash" />
                </Button>
              </Table.Cell>
            : null}
          </Table.Row>
        ))}
        {isEditing ?
          <Table.Row>
            <Table.Cell colSpan={(columns.length || 1) + (isEditing ? 1 : 0)}>
              <Button
                primary
                onClick={() => {
                  const newData = [...currentData, {}];
                  updateIdea({ ...(fieldValue || {}), data: newData }, [
                    "templated",
                    field.id,
                  ]);
                }}
              >
                Add Row
              </Button>
            </Table.Cell>
          </Table.Row>
        : null}
      </Table.Body>
    </Table>
  );
};

export default TableField;
